module.exports = __webpack_public_path__ + "img/Sharepoint365.c1acd591.svg";